// extracted by mini-css-extract-plugin
module.exports = {"carServiceWhatYouGet":"_35nQ8","carServiceWrapper":"_2G5Yo","carServiceCard":"_1g4Cl"};